module.exports = __webpack_public_path__ + "static/media/headerLogo.6095221e.png";